function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
// Bundled with Packemon: https://packemon.dev
// Platform: browser, Support: stable, Format: esm

import Cookies from 'js-cookie';

// TODO: Add a Cross validation for locale names in `supportedLocales.ts`
// TODO: Add build step to pull the config from CDN
// Until automation, periodically copy from https://translations.coinbase.com/locales/low/config.json

const supportedCountryCodes = {
  US: 'US',
  DE: 'DE',
  GB: 'GB',
  FR: 'FR',
  CA: 'CA',
  PT: 'PT',
  BR: 'BR',
  ES: 'ES',
  SG: 'SG',
  AU: 'AU',
  IT: 'IT',
  NL: 'NL',
  TR: 'TR'
};
const languages = {
  en: {
    name: 'English',
    code: 'en'
  },
  es: {
    name: 'Español',
    code: 'es'
  },
  fr: {
    name: 'Français',
    code: 'fr'
  },
  de: {
    name: 'Deutsch',
    code: 'de'
  },
  it: {
    name: 'Italiano',
    code: 'it'
  },
  nl: {
    name: 'Nederlands',
    code: 'nl'
  },
  pl: {
    name: 'Polski',
    code: 'pl'
  },
  pt: {
    name: 'Português',
    code: 'pt'
  },
  ru: {
    name: 'Русский',
    code: 'ru'
  },
  th: {
    name: 'ไทย',
    code: 'th'
  },
  tr: {
    name: 'Türkçe',
    code: 'tr'
  },
  zh: {
    name: '中文',
    code: 'zh'
  },
  id: {
    name: 'Bahasa Indonesia',
    code: 'id'
  }
};

// TODO: Improve typing by explicitly maps the keys with the supported locales instead of `string`

const DEFAULT_LOGGED_OUT_CONFIG = {
  us: {
    country_code: supportedCountryCodes.US,
    country_name: 'United States',
    default_locale: 'en',
    supported_locales: [languages.es.code, languages.en.code]
  },
  de: {
    country_code: supportedCountryCodes.DE,
    country_name: 'Germany',
    default_locale: 'de',
    supported_locales: [languages.de.code, languages.en.code],
    is_default_locale_single_path: true
  },
  gb: {
    country_code: supportedCountryCodes.GB,
    country_name: 'United Kingdom',
    default_locale: 'en',
    supported_locales: [languages.en.code]
  },
  fr: {
    country_code: supportedCountryCodes.FR,
    country_name: 'France',
    default_locale: 'fr',
    supported_locales: [languages.en.code, languages.fr.code]
  },
  ca: {
    country_code: supportedCountryCodes.CA,
    country_name: 'Canada',
    default_locale: 'en',
    supported_locales: [languages.en.code, languages.fr.code]
  },
  es: {
    country_code: supportedCountryCodes.ES,
    country_name: 'Spain',
    default_locale: 'es',
    supported_locales: [languages.es.code, languages.en.code]
  },
  br: {
    country_code: supportedCountryCodes.BR,
    country_name: 'Brazil',
    default_locale: 'pt',
    supported_locales: [languages.pt.code, languages.en.code]
  },
  pt: {
    country_code: supportedCountryCodes.PT,
    country_name: 'Portugal',
    default_locale: 'pt',
    supported_locales: [languages.pt.code, languages.en.code]
  },
  au: {
    country_code: supportedCountryCodes.AU,
    country_name: 'Australia',
    default_locale: 'en',
    supported_locales: [languages.en.code]
  },
  sg: {
    country_code: supportedCountryCodes.SG,
    country_name: 'Singapore',
    default_locale: 'en',
    supported_locales: [languages.en.code, languages.zh.code]
  },
  it: {
    country_code: 'IT',
    country_name: 'Italy',
    default_locale: 'it',
    supported_locales: [languages.it.code, languages.en.code],
    is_default_locale_single_path: true
  },
  nl: {
    country_code: 'NL',
    country_name: 'Netherlands',
    default_locale: 'nl',
    supported_locales: [languages.nl.code, languages.en.code],
    is_default_locale_single_path: true
  },
  tr: {
    country_code: 'TR',
    country_name: 'Turkey',
    default_locale: 'tr',
    supported_locales: [languages.tr.code, languages.en.code],
    is_default_locale_single_path: true
  }
  // tw: {
  //   country_code: 'TW',
  //   country_name: 'Taiwan',
  //   default_locale: 'zh',
  //   supported_locales: [languages.zh.code, languages.en.code],
  // },
  // cn: {
  //   country_code: 'CN',
  //   country_name: 'China',
  //   default_locale: 'zh',
  //   supported_locales: [languages.zh.code, languages.en.code],
  // },
  // hk: {
  //   country_code: 'HK',
  //   country_name: 'Hong Kong',
  //   default_locale: 'zh',
  //   supported_locales: [languages.zh.code, languages.en.code],
  // },
  // pl: {
  //   country_code: 'PL',
  //   country_name: 'Polish',
  //   default_locale: 'pl',
  //   supported_locales: ['pl', 'en'],
  //   is_default_locale_single_path: true,
  // },
  // ru: {
  //   country_code: 'RU',
  //   country_name: 'Russia',
  //   default_locale: 'ru',
  //   supported_locales: ['ru', 'en'],
  // },
};

// Update this list when altering the above default config
const FALLBACK_LOCALES = [
// TODO: @gokul.kathirvel - Do not define an another list.
// Consolidate this
'es-LA', 'fr', 'pl', 'ru', 'th', 'zh-CN', 'zh-TW'];
const TRANSLATION_BASE_URLS = {
  production: 'https://translations.coinbase.com',
  development: 'https://translations.cbhq.net'
};
function getTranslationBaseUrl(cdnEnv) {
  return TRANSLATION_BASE_URLS[cdnEnv] || TRANSLATION_BASE_URLS.production; // fallback to prod as its accessible and up to date
}

// Structure in which the config will be exported to the clients.

function getCdnUrl$1(env) {
  const CDN_BASE_URL = getTranslationBaseUrl(env);
  return `${CDN_BASE_URL}/locales/apps/loggedout/www.json`;
}
async function fetchLoggedOutConfig(params = {}) {
  const _params$env = params.env,
    env = _params$env === void 0 ? process.env.NODE_ENV : _params$env;
  const url = getCdnUrl$1(env);
  let config = {};
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Bad Response', {
        cause: response
      });
    }
    const json = await response.json();
    config = json?.config || {};
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Error while fetching the config. Falling back to the predefined map', error);
    config = DEFAULT_LOGGED_OUT_CONFIG;
  }
  return config;
}
function getLangDetails(langTag) {
  return languages[langTag];
}

/*
Convert the config map to a list of country configs to make it iterable
End structure: CountryConfig[]
*/
function validateAndConvertToList(config) {
  const countryConfig = Object.values(config).map(countryConfigItem => {
    const _countryConfigItem$su = countryConfigItem.supported_locales,
      languages = _countryConfigItem$su === void 0 ? [] : _countryConfigItem$su,
      countryCode = countryConfigItem.country_code;

    // For each country config:
    const supportedLocales = languages.map(langTag => {
      const lookedUpLocale = getLangDetails(langTag);

      // If the locale is not supported, log an error and return null
      // TODO: add validation in TGS while publishing the config
      if (!lookedUpLocale) {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(`A language specified in the config for ${countryCode} is not supported: ${langTag}`);
        }
        return null;
      }
      return {
        tag: langTag,
        // ex: fr
        name: lookedUpLocale.name,
        // ex: French
        code: `${langTag}-${countryCode}`.toLowerCase() // ex: fr-ca
      };
    });
    const filteredLocales = supportedLocales.filter(Boolean);
    return _objectSpread(_objectSpread({}, countryConfigItem), {}, {
      supported_locales: filteredLocales || []
    });
  });
  return countryConfig;
}

/*
This class is exposed to clients.
Clients can:

```
  import { loggedOutConfig } from '@cbhq/intl';

  // Fetch the entire config json
  const config = await loggedOutConfig.getConfig();

  // Get config for each country. Ex: Canada 
  const configForCA = await loggedOutConfig.getConfigFor('CA');
```

TODO: Update docs
*/

class LoggedOutConfig {
  constructor() {
    this.config = null;
    this.configList = [];
  }
  async fetch(params = {}) {
    this.config = await fetchLoggedOutConfig(params);
    this.configList = validateAndConvertToList(this.config) || [];
    return {
      config: this.config,
      configList: this.configList
    };
  }
  async getConfig(params = {}) {
    if (!this.config) {
      const _await$this$fetch = await this.fetch(params),
        config = _await$this$fetch.config;
      return config;
    }
    return this.config;
  }
  async getConfigList(params = {}) {
    if (!this.config) {
      const _await$this$fetch2 = await this.fetch(params),
        configList = _await$this$fetch2.configList;
      return configList;
    }
    return this.configList;
  }

  /**
   * Returns a config for a given country code
   * @param {string}. Ex: "CA"
   * @return {CountryConfig}. 
   * Sample: {
        country_name: 'Canada',
        country_code: 'ca',
        default_locale: 'en',
        is_default_locale_single_path: false,
        supported_locales: [{
          locale_name: 'English',
          locale_code: 'en',
        }, {
          locale_name: 'French',
          locale_code: 'fr',
        }],
      }
   */
  async getConfigFor(countryCode, params = {}) {
    const config = await this.getConfigList(params);
    return config?.find(_config => _config.country_code?.toLowerCase() === countryCode?.toLowerCase());
  }
}

// These 3 methods are sync and directly exposing the hardcoded list
// for the ease of use.
// TODD: @gokul.kathirvel - Investigate the bottleneck of using the async version
function getLoggedOutConfig() {
  return DEFAULT_LOGGED_OUT_CONFIG;
}
function getLoggedOutConfigList() {
  return validateAndConvertToList(getLoggedOutConfig());
}
function getLoggedOutConfigFor(countryCode) {
  return getLoggedOutConfigList()?.find(_config => _config.country_code?.toLowerCase() === countryCode?.toLowerCase());
}
function getLoggedOutFallbackLocales() {
  return FALLBACK_LOCALES;
}

// Export singleton instance
const loggedOutConfig = new LoggedOutConfig();
const DEFAULT_LOCALE = 'en';
const DEFAULT_REGION = 'US';

/**
 * From https://docs.google.com/spreadsheets/d/1Qvu404rHc-QvIo8vzisbzdy4kKbYi5xb7hBWTTeYzwU/edit#gid=0
 * This is the currently supported list of locales for use with smartling
 */
const DEFAULT_SUPPORTED_LANGUAGES = {
  de: ['Deutsch', 'German'],
  en: ['English', 'English'],
  'es-ES': ['Español (España)', 'Spanish (Spain)'],
  'es-LA': ['Español (Latinoamérica)', 'Spanish (Latin America)'],
  fr: ['Français', 'French'],
  id: ['Bahasa Indonesia', 'Indonesian'],
  it: ['Italiano', 'Italian'],
  // ko: ['한국의', 'Korean'], // Removed as part of the recent legal ask - I18N-295
  nl: ['Nederlands', 'Dutch'],
  pl: ['Polski', 'Polish'],
  'pt-BR': ['Português (Brasil)', 'Portuguese (Brazil)'],
  'pt-PT': ['Português (Portugal)', 'Portuguese (Portugal)'],
  ru: ['Pусский', 'Russian'],
  th: ['ไทย', 'Thai'],
  tr: ['Türkçe', 'Turkish'],
  'zh-CN': ['中文 (简体)', 'Simplified Chinese'],
  'zh-TW': ['中文 (繁體)', 'Traditional Chinese (Taiwan)']
};
const localeCodeToDisplayName = DEFAULT_SUPPORTED_LANGUAGES;
const SUPPORTED_LOCALES = Object.keys(DEFAULT_SUPPORTED_LANGUAGES);
const LOCALE_CONVERSIONS = {
  pt: 'pt-BR',
  zh: 'zh-CN',
  es: 'es-ES',
  'es-419': 'es-LA',
  'es-MX': 'es-LA'
};
function getCountryFromHeaders(headers) {
  return headers?.['cf-ipcountry'] ??
  // Cloudflare will strip the cf-ipcountry request header when IP geolocation is disabled
  // even when it is supplied by some upstream Cloudflare instance, so we alias it to 'cb-ipcountry'
  headers?.['cb-ipcountry'] ?? DEFAULT_REGION;
}
function computeLocaleCode({
  languageCode,
  countryCode: _countryCode,
  countryDefaultLocale,
  isDefaultLocaleSinglePath
}) {
  const countryCode = _countryCode.toLowerCase();
  let localeCode;
  if (languageCode === DEFAULT_LOCALE && countryCode === DEFAULT_REGION.toLowerCase()) {
    // Skip en-us as it is the default. ie., coinbase.com/ will be considered as coinbase.com/en-us
    // Continue seems to the straight forward way to skip the iteration
    localeCode = '';
  } else if (isDefaultLocaleSinglePath && languageCode === countryDefaultLocale) {
    localeCode = languageCode;
  } else {
    localeCode = countryCode ? `${languageCode}-${countryCode}` : languageCode;
  }
  return localeCode.toLowerCase();
}
function getDefaultLoggedOutConfigWithFallback() {
  /**
    The default config is the one we use for www (coinbase.com marketing server)
    This should include the legacy (and fallback) locales where we don't have support
    the country yet (ex: ja, ru etc,)
     Hence, we added an another placeholder entry for global edition which contains
    the fallback locales
   */
  const globalFallback = {
    country_code: '',
    supported_locales: getLoggedOutFallbackLocales(),
    country_name: '',
    default_locale: ''
  };
  return _objectSpread(_objectSpread({}, getLoggedOutConfig()), {}, {
    global: globalFallback
  });
}
function getSupportedLocalesFromConfig(clientConfig) {
  // If the config is not passed, use the default config for www
  const config = clientConfig ?? getDefaultLoggedOutConfigWithFallback();
  const localeCombinations = [];
  if (!config) {
    return [];
  }
  for (const _ref of Object.entries(config)) {
    var _ref2 = _slicedToArray(_ref, 2);
    const configObject = _ref2[1];
    const defaultLocale = configObject.default_locale,
      isDefaultLocaleSinglePath = configObject.is_default_locale_single_path,
      countryCode = configObject.country_code;
    const normalizedCountryCode = countryCode.toLowerCase();

    // For each supported locale, create a combination

    for (const languageCode of configObject.supported_locales) {
      const computedLocale = computeLocaleCode({
        languageCode,
        countryCode: normalizedCountryCode,
        countryDefaultLocale: defaultLocale,
        isDefaultLocaleSinglePath: !!isDefaultLocaleSinglePath
      });
      if (computedLocale) {
        localeCombinations.push(computedLocale);
      }
    }
  }
  return [...new Set(localeCombinations)];
}
function isPathExcluded(req, excludes) {
  if (excludes.length === 0) {
    return false;
  }
  const regex = new RegExp(`^(?:${excludes.join('|')})/?`);
  return !!req.url.match(regex);
}
function getBaseLocale(locale) {
  const _locale$split = locale.split('-'),
    _locale$split2 = _slicedToArray(_locale$split, 1),
    language = _locale$split2[0];
  return language;
}
function isPathLocalized(requestUrl, supportedLocales) {
  if (supportedLocales.length === 0) {
    return false;
  }
  const urlNormalized = requestUrl.toLowerCase();
  const subfolderLocalizationRegEx = new RegExp(`^/(${supportedLocales.join('|')})((/|\\?|#).*)?$`);
  const regexMatch = urlNormalized.match(subfolderLocalizationRegEx);
  return !!regexMatch;
}
function isValidConfigMapKey(code, config) {
  return Object.keys(config).includes(code.toLowerCase());
}

// This fallback is only for locale and not for the URL mapping
// which will be done in the main function.
// For ex: if an user comes with `es-419` as the supported locale,
// we will convert that locale to `es-la` which is the CB supported locale.
const knownFallbacksForLocale = {
  'es-419': 'es-la',
  'es-mx': 'es-la',
  pt: 'pt-br',
  zh: 'zh-cn'
  // TODO: @gokul.kathirvel check ES here
};
function getLocaleWithFallback(locale, supportedLocales) {
  if (supportedLocales.includes(locale)) {
    return locale;
  }
  const convertedLocale = knownFallbacksForLocale[locale]?.toLowerCase();
  if (convertedLocale && supportedLocales.includes(convertedLocale)) {
    return convertedLocale;
  }
  return '';
}
function getCBSupportedLocale(_locale, _supportedLocales) {
  const locale = _locale.toLowerCase();
  const supportedLocales = _supportedLocales.map(l => l.toLowerCase());
  const cbLocale = getLocaleWithFallback(locale, supportedLocales);
  if (cbLocale) {
    return cbLocale;
  }
  if (locale.includes('-')) {
    const baseLocale = locale.split('-')[0];
    const cbLocaleForBase = getLocaleWithFallback(baseLocale, supportedLocales);
    if (cbLocaleForBase) {
      return cbLocaleForBase;
    }
  }
  return '';
}
function getPreferredLanguage(acceptLanguage, supportedLocalesForCountry) {
  // get first and send language preference from the header
  // Split by comma and take the first two values (if they exist)
  const languages = acceptLanguage.split(',').map(lang => lang.split(';')[0].trim());
  const primaryLang = languages[0] || '';
  const secondaryLang = languages[1] || '';
  const cbLocale = getCBSupportedLocale(primaryLang, supportedLocalesForCountry);
  if (cbLocale) {
    return cbLocale;
  }
  const cbLocaleForSecondary = getCBSupportedLocale(secondaryLang, supportedLocalesForCountry);
  if (cbLocaleForSecondary) {
    return cbLocaleForSecondary;
  }
  return '';
}

/**
 * If the requestURL is empty - we assume that is a root path and localize
 * If the country is empty - There will not be any localization happen
 * If the acceptLanguage is empty - We consider the default locale for the market as the target locale
 * If the config is empty - There will not be any localization happen
 */
function getLocalizedURL({
  requestUrl,
  // This may contain query params, hash anchors etc.
  country: _country,
  acceptLanguage,
  config,
  supportedLocales
}) {
  const country = _country.toLowerCase();

  // Do not process if
  // 1. the country is not supported
  // 2. the requestUrl is already localized
  if (isPathLocalized(requestUrl, supportedLocales) || !isValidConfigMapKey(country, config) || !config[country]) {
    return requestUrl;
  }
  const _config$country = config[country],
    supportedLocalesForCountry = _config$country.supported_locales,
    defaultLocale = _config$country.default_locale,
    isDefaultLocaleSinglePath = _config$country.is_default_locale_single_path;
  const preferredLanguage = getPreferredLanguage(acceptLanguage, supportedLocalesForCountry) || defaultLocale;
  if (country === DEFAULT_REGION.toLowerCase() && preferredLanguage === 'en') {
    // If it's an US user + Language is english.
    // Normal US user case. No redirection required.
    return requestUrl;
  }
  let locale = `${preferredLanguage}-${country}`;
  if (isDefaultLocaleSinglePath && preferredLanguage === defaultLocale) {
    locale = getBaseLocale(defaultLocale);
  }
  return `/${locale}${requestUrl}`;
}
function autoRedirectionExpressMiddleware(req, res, next, options) {
  const config = options.config,
    _options$exclude = options.exclude,
    exclude = _options$exclude === void 0 ? [] : _options$exclude,
    supportedLocales = options.supportedLocales;
  const url = req.url,
    headers = req.headers,
    query = req.query;
  if (isPathExcluded(req, exclude)) {
    return next();
  }
  const langHeader = headers?.['accept-language'];
  const country = query.country ?? getCountryFromHeaders(headers);
  const localizedUrl = getLocalizedURL({
    requestUrl: url,
    country,
    acceptLanguage: langHeader ?? '',
    config,
    supportedLocales
  });
  if (localizedUrl !== req.url) {
    return res.redirect(302, localizedUrl);
  }
  return next();
}

// Middleware wrapper will run on startup only. not on each request.
function autoRedirection(options) {
  const _ref3 = options ?? {},
    configFromArg = _ref3.config;
  const config = configFromArg ?? getLoggedOutConfig();

  // getSupportedLocalesFromConfig(config) => extract supported locales from config
  // getSupportedLocalesFromConfig() => extract supported locales from default config + fallback for LOW
  // hence, we should pass the config from argument (it can be config or undefined).
  const supportedLocales = getSupportedLocalesFromConfig(configFromArg);
  return (req, res, next) => autoRedirectionExpressMiddleware(req, res, next, _objectSpread(_objectSpread({}, options), {}, {
    config,
    supportedLocales
  }));
}
function lookupFromPredefinedList(locale) {
  if (SUPPORTED_LOCALES.includes(locale)) return locale;
  if (LOCALE_CONVERSIONS[locale]) return LOCALE_CONVERSIONS[locale];
  return '';
}
function convertToCBSupported(locale) {
  const localeMatchedFromPredefinedList = lookupFromPredefinedList(locale);
  if (localeMatchedFromPredefinedList) {
    return localeMatchedFromPredefinedList;
  }
  if (locale.includes('-')) {
    const baseLocale = locale.split('-')[0];
    if (SUPPORTED_LOCALES.includes(baseLocale)) {
      return baseLocale;
    }
    if (LOCALE_CONVERSIONS[baseLocale]) return LOCALE_CONVERSIONS[baseLocale];
  }
  // Return English if the locale isn't supported it is already default for react Intl
  // eslint-disable-next-line no-console
  console.warn(`${locale} not supported yet`);
  return DEFAULT_LOCALE;
}

// countries list come froms app/models/concerns/user_international.rb
// @see http://ec.europa.eu/eurostat/statistics-explained/index.php/Glossary:Country_codes
// @note The code UK is used by them for United Kingdom, but the official ISO standard uses GB.
const EUROPEAN_UNION_LIST = ['BE',
// Belgium
'BG',
// Bulgaria
'CZ',
// Czech Republic
'DK',
// Denmark
'DE',
// Germany
'EE',
// Estonia
'IE',
// Ireland
'GR',
// Greece
'ES',
// Spain
'FR',
// France
'HR',
// Croatia
'IT',
// Italy
'CY',
// Cyprus
'LV',
// Latvia
'LT',
// Lithuania
'LU',
// Luxembourg
'HU',
// Hungary
'MT',
// Malta
'NL',
// Netherlands
'AT',
// Austria
'PL',
// Poland
'PT',
// Portugal
'RO',
// Romania
'SI',
// Slovenia
'SK',
// Slovakia
'FI',
// Finland
'SE',
// Sweden
'GB' // United Kingdom
];

// European Free Trade Association (EFTA)
const EFTA_LIST = ['IS',
// Iceland
'LI',
// Liechtenstein
'NO',
// Norway
'CH' // Switzerland
];

// List of newly added Regions that are getting access to SEPA.
// The list is used to disallow Worldpay/Secure3D support,
// make sure they are receive GDPR restrictions,
// and excuse older users from upfront EDP (KYC) and IDV.
const DEC_2018_SUPPORTED_EUROPEAN_COUNTRIES = ['AD',
// Andorra
'GG',
// Guernsey
'GI',
// Gibraltar
'IM',
// Isle of Man
'IS',
// Iceland
'LT' // Lithuania
];
const GDPR_COUNTRIES = [...EUROPEAN_UNION_LIST, ...EFTA_LIST, ...DEC_2018_SUPPORTED_EUROPEAN_COUNTRIES]; // Most legal regulation applies to both the EU and the EFTA, so keep a combined list.

const OFFICIAL_EU_COUNTRIES = [...EUROPEAN_UNION_LIST, ...EFTA_LIST];
function isInEU(countryCode) {
  return OFFICIAL_EU_COUNTRIES.includes(countryCode.toUpperCase());
}
function isGdprCountry(countryCode) {
  return GDPR_COUNTRIES.includes(countryCode.toUpperCase());
}
const Apps = {
  RETAIL: 'retail',
  WALLET: 'wallet'
};
function getCdnUrl(cdnEnv, appId) {
  const CDN_BASE_URL = getTranslationBaseUrl(cdnEnv);
  const LOCALE_LIST_URL = `${CDN_BASE_URL}/locales/apps/${appId}.json`;
  return LOCALE_LIST_URL;
}
function constructFallback() {
  return Object.entries(DEFAULT_SUPPORTED_LANGUAGES).map(localeEntry => {
    const _localeEntry = _slicedToArray(localeEntry, 2),
      key = _localeEntry[0],
      localesNames = _localeEntry[1];
    return {
      display_name: localesNames[0],
      locale: key
    };
  });
}
async function fetchSupportedLocales(appId, params) {
  const _params$cdnEnv = params.cdnEnv,
    cdnEnv = _params$cdnEnv === void 0 ? process.env.NODE_ENV : _params$cdnEnv;
  const url = getCdnUrl(cdnEnv, appId);
  let locales = [];
  try {
    const response = await fetch(url);
    if (!response.ok) {
      throw new Error('Bad Response');
    }
    const json = await response.json();
    locales = json.supported_locales;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('Error while fetching the supported locales. Falling back to the predefined list', error);
    locales = constructFallback();
  }
  return locales;
}
async function fetchSupportedLocalesWithFallback(appId, params) {
  const locales = await fetchSupportedLocales(appId, params);
  const legacyMapping = {
    'es-ES': 'es',
    'pt-BR': 'pt'
  };
  const legacyLocales = locales.map(localeItem => {
    const legacyLocale = legacyMapping[localeItem.locale];
    return _objectSpread(_objectSpread({}, localeItem), {}, {
      locale: legacyLocale || localeItem.locale
    });
  });
  return legacyLocales;
}
function getLocaleCodeWithoutRegion(locale) {
  return locale.toLowerCase().split(/[_-]+/)[0] || DEFAULT_LOCALE;
}
const regionsLA = ['es-AR', 'es-CL', 'es-CO', 'es-CR', 'es-EC', 'es-mx', 'es-NI', 'es-PA', 'es-PE', 'es-US', 'es-VE'];
function getLocaleFallback(locale) {
  if (regionsLA.some(r => r.toLowerCase() === locale.toLowerCase())) {
    return 'es-LA';
  }
  if (locale === 'es') return 'es-ES';
  if (locale === 'pt') return 'pt-BR';
  return getLocaleCodeWithoutRegion(locale);
}
function getNavigatorLocale() {
  let locale;
  if (navigator.languages && navigator.languages.length > 0) {
    var _navigator$languages = _slicedToArray(navigator.languages, 1);
    locale = _navigator$languages[0];
  } else {
    // @ts-expect-error userLanguage is for IE
    locale = navigator.language || navigator.userLanguage;
  }
  if (locale && !SUPPORTED_LOCALES.includes(locale)) {
    const localeFallback = getLocaleFallback(locale);
    if (SUPPORTED_LOCALES.includes(localeFallback)) {
      return localeFallback;
    }
    return null;
  }
  return locale;
}

// This is used to determine the client locale code for both marketing and app
// as a fallback when the locale is not provided in the path or defined on the user object
function getClientFallbackLocaleCode() {
  const cookieLocale = Cookies.get('coinbase_locale');
  return (cookieLocale ?? getNavigatorLocale() ?? DEFAULT_LOCALE).toLowerCase();
}
function normalizeLocale(locale) {
  const languageParts = locale.split('-');

  // xx
  if (languageParts.length < 2) {
    return locale.toLowerCase();
  }
  const languageCode = languageParts[0].toLowerCase();
  const regionOrScriptCode = languageParts[1];

  // xx-XX
  if (regionOrScriptCode.length === 2) {
    return languageCode.concat('-', regionOrScriptCode.toUpperCase());
  }

  // xx-Xxxx
  if (regionOrScriptCode.length === 4) {
    return languageCode.concat('-', regionOrScriptCode.charAt(0).toUpperCase() + regionOrScriptCode.slice(1).toLowerCase());
  }
  return languageCode;
}
const COINBASE_LOCALE_COOKIE = 'coinbase_locale';
const FALLBACK_LOCALE_COOKIE = 'cached_locale';

// NOTE:
// Most packages should not be looking at the client's locale / cookie.
// - For logged in apps: should use the locale stored in account settings (ex: user service in retail)
// - For any packages: to accept locale from the host app and not to determine the locale themselves in the package
// Valid usage for these helpers: logged-out app

// Note for `getClientLocale`:
// Please consider using getCbSupportedClientLocale for most use-cases which maps locale to CB supported locale
// This is only useful if you want to get the raw locale from the user.
function getClientLocale(cookieName = COINBASE_LOCALE_COOKIE) {
  const locale = normalizeLocale(Cookies.get(cookieName) ?? navigator.languages?.[0] ?? navigator.language ?? DEFAULT_LOCALE);
  return locale === 'en-US' ? DEFAULT_LOCALE : locale;
}
function getCbSupportedClientLocale() {
  const locale = normalizeLocale(Cookies.get(COINBASE_LOCALE_COOKIE) ?? Cookies.get(FALLBACK_LOCALE_COOKIE) ?? navigator.languages?.[0] ?? navigator.language ?? DEFAULT_LOCALE);
  const loc = locale === 'en-US' ? DEFAULT_LOCALE : locale;
  return convertToCBSupported(loc);
}

// Taken from the Country module in rails with:
// Country.codes.map{|c| [c, Country[c].try(:currency_code)] }
const codes = new Map([['AD', 'EUR'], ['AE', 'AED'], ['AF', 'AFN'], ['AG', 'XCD'], ['AI', 'XCD'], ['AL', 'ALL'], ['AM', 'AMD'], ['AO', 'AOA'], ['AQ', 'USD'], ['AR', 'ARS'], ['AS', 'USD'], ['AT', 'EUR'], ['AU', 'AUD'], ['AW', 'AWG'], ['AX', 'EUR'], ['AZ', 'AZN'], ['BA', 'BAM'], ['BB', 'BBD'], ['BD', 'BDT'], ['BE', 'EUR'], ['BF', 'XOF'], ['BG', 'BGN'], ['BH', 'BHD'], ['BI', 'BIF'], ['BJ', 'XOF'], ['BL', 'EUR'], ['BM', 'BMD'], ['BN', 'BND'], ['BO', 'BOB'], ['BQ', 'USD'], ['BR', 'BRL'], ['BS', 'BSD'], ['BT', 'BTN'], ['BV', 'NOK'], ['BW', 'BWP'], ['BY', 'BYR'], ['BZ', 'BZD'], ['CA', 'CAD'], ['CC', 'AUD'], ['CD', 'CDF'], ['CF', 'XAF'], ['CG', 'XAF'], ['CH', 'CHF'], ['CI', 'XOF'], ['CK', 'NZD'], ['CL', 'CLP'], ['CM', 'XAF'], ['CN', 'CNY'], ['CO', 'COP'], ['CR', 'CRC'], ['CU', 'CUP'], ['CV', 'CVE'], ['CW', 'ANG'], ['CX', 'AUD'], ['CY', 'EUR'], ['CZ', 'CZK'], ['DE', 'EUR'], ['DJ', 'DJF'], ['DK', 'DKK'], ['DM', 'XCD'], ['DO', 'DOP'], ['DZ', 'DZD'], ['EC', 'USD'], ['EE', 'EUR'], ['EG', 'EGP'], ['EH', 'MAD'], ['ER', 'ETB'], ['ES', 'EUR'], ['ET', 'ETB'], ['FI', 'EUR'], ['FJ', 'USD'], ['FK', 'FKP'], ['FM', 'USD'], ['FO', 'DKK'], ['FR', 'EUR'], ['GA', 'XAF'], ['GB', 'GBP'], ['GD', 'XCD'], ['GE', 'GEL'], ['GF', 'EUR'], ['GG', 'GBP'], ['GH', 'GHS'], ['GI', 'GIP'], ['GL', 'DKK'], ['GM', 'GMD'], ['GN', 'GNF'], ['GP', 'EUR'], ['GQ', 'XAF'], ['GR', 'EUR'], ['GS', 'GBP'], ['GT', 'GTQ'], ['GU', 'USD'], ['GW', 'XOF'], ['GY', 'GYD'], ['HK', 'HKD'], ['HM', 'AUD'], ['HN', 'HNL'], ['HR', 'HRK'], ['HT', 'USD'], ['HU', 'HUF'], ['ID', 'IDR'], ['IE', 'EUR'], ['IL', 'ILS'], ['IM', 'IMP'], ['IN', 'INR'], ['IO', 'USD'], ['IQ', 'IQD'], ['IR', 'IRR'], ['IS', 'ISK'], ['IT', 'EUR'], ['JE', 'JEP'], ['JM', 'JMD'], ['JO', 'JOD'], ['JP', 'JPY'], ['KE', 'KES'], ['KG', 'KGS'], ['KH', 'KHR'], ['KI', 'AUD'], ['KM', 'KMF'], ['KN', 'XCD'], ['KP', 'KPW'], ['KR', 'KRW'], ['KW', 'KWD'], ['KY', 'KYD'], ['KZ', 'KZT'], ['LA', 'LAK'], ['LB', 'LBP'], ['LC', 'XCD'], ['LI', 'CHF'], ['LK', 'LKR'], ['LR', 'LRD'], ['LS', 'LSL'], ['LT', 'EUR'], ['LU', 'EUR'], ['LV', 'EUR'], ['LY', 'LYD'], ['MA', 'MAD'], ['MC', 'EUR'], ['MD', 'MDL'], ['ME', 'EUR'], ['MF', 'EUR'], ['MG', 'MGA'], ['MH', 'USD'], ['MK', 'MKD'], ['ML', 'XOF'], ['MM', 'MMK'], ['MN', 'MNT'], ['MO', 'MOP'], ['MP', 'USD'], ['MQ', 'EUR'], ['MR', 'MRO'], ['MS', 'XCD'], ['MT', 'EUR'], ['MU', 'MUR'], ['MV', 'MVR'], ['MW', 'MWK'], ['MX', 'MXN'], ['MY', 'MYR'], ['MZ', 'MZN'], ['NA', 'NAD'], ['NC', 'XPF'], ['NE', 'XOF'], ['NF', 'AUD'], ['NG', 'NGN'], ['NI', 'NIO'], ['NL', 'EUR'], ['NO', 'NOK'], ['NP', 'NPR'], ['NR', 'AUD'], ['NU', 'NZD'], ['NZ', 'NZD'], ['OM', 'OMR'], ['PA', 'PAB'], ['PE', 'PEN'], ['PF', 'XPF'], ['PG', 'PGK'], ['PH', 'PHP'], ['PK', 'PKR'], ['PL', 'PLN'], ['PM', 'EUR'], ['PN', 'NZD'], ['PR', 'USD'], ['PS', 'ILS'], ['PT', 'EUR'], ['PW', 'USD'], ['PY', 'PYG'], ['QA', 'QAR'], ['RE', 'EUR'], ['RO', 'RON'], ['RS', 'RSD'], ['RU', 'RUB'], ['RW', 'RWF'], ['SA', 'SAR'], ['SB', 'SBD'], ['SC', 'SCR'], ['SD', 'SDG'], ['SE', 'SEK'], ['SG', 'SGD'], ['SH', 'SHP'], ['SI', 'EUR'], ['SJ', 'NOK'], ['SK', 'EUR'], ['SL', 'SLL'], ['SM', 'EUR'], ['SN', 'XOF'], ['SO', 'SOS'], ['SR', 'SRD'], ['SS', 'SSP'], ['ST', 'STD'], ['SV', 'USD'], ['SX', 'ANG'], ['SY', 'SYP'], ['SZ', 'SZL'], ['TC', 'USD'], ['TD', 'XAF'], ['TF', 'EUR'], ['TG', 'XOF'], ['TH', 'THB'], ['TJ', 'TJS'], ['TK', 'NZD'], ['TL', 'IDR'], ['TM', 'TMT'], ['TN', 'TND'], ['TO', 'TOP'], ['TR', 'TRY'], ['TT', 'TTD'], ['TV', 'TVD'], ['TW', 'TWD'], ['TZ', 'TZS'], ['UA', 'UAH'], ['UG', 'UGX'], ['UM', 'USD'], ['US', 'USD'], ['UY', 'UYU'], ['UZ', 'UZS'], ['VA', 'EUR'], ['VC', 'XCD'], ['VE', 'VEF'], ['VG', 'USD'], ['VI', 'USD'], ['VN', 'VND'], ['VU', 'VUV'], ['WF', 'XPF'], ['WS', 'USD'], ['YE', 'YER'], ['YT', 'EUR'], ['ZA', 'ZAR'], ['ZM', 'ZMW'], ['ZW', 'USD']]);
const distinctCurrencies = new Set(codes.values());
function isValidCurrencyCode(code) {
  return distinctCurrencies.has(code.toUpperCase());
}
function getCurrencyForRegion(countryCode) {
  return codes.get(countryCode.toUpperCase()) ?? 'USD';
}
function getRegionFromLocaleCode(locale) {
  const parts = locale.toUpperCase().split(/[_-]+/);
  let result = '';
  if (parts.length > 1) {
    var _parts = _slicedToArray(parts, 2);
    result = _parts[1];
  } else if (parts.length > 0) {
    var _parts2 = _slicedToArray(parts, 1);
    result = _parts2[0];
  }
  return result || DEFAULT_REGION;
}

// @ts-expect-error TS thinks its an invalid module

async function retrieveEtag(db, key) {
  try {
    const translationEtag = await db.get('etags', key);
    return translationEtag;
  } catch (error) {
    return '';
  }
}
async function retrieveIDBMessages(db, key) {
  try {
    const messages = (await db.get('messages', key)) ?? {};
    return messages;
  } catch (error) {
    return {};
  }
}
async function initiateIDB(dbName) {
  try {
    const _await$import = await import('idb'),
      openDB = _await$import.openDB;
    return await openDB(dbName, 1, {
      upgrade(dbTable) {
        dbTable.createObjectStore('etags');
        dbTable.createObjectStore('messages');
      }
    });
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
    return {};
  }
}
async function parseMessagesPayload(res) {
  const messages = {};
  const payload = await res.json();
  Object.entries(payload).forEach(([key, value]) => {
    if (key !== 'smartling') {
      messages[key] = value?.message || value?.defaultMessage;
    }
  });
  return messages;
}
async function fetchMessagesRaw(locale, smartlingProjectID, serviceIdentifier, params) {
  const _params$cdnEnv2 = params.cdnEnv,
    cdnEnv = _params$cdnEnv2 === void 0 ? process.env.NODE_ENV : _params$cdnEnv2,
    _params$headers = params.headers,
    headers = _params$headers === void 0 ? {} : _params$headers;
  const domain = cdnEnv !== 'production' ? 'translations.cbhq.net' : 'translations.coinbase.com';
  const serviceIdentifierSegment = serviceIdentifier ? `${serviceIdentifier}/` : '';
  const downloadUrl = `https://${domain}/${smartlingProjectID}/${serviceIdentifierSegment}latest/${locale}/messages.json`;
  return fetch(downloadUrl, {
    headers: headers
  });
}
async function fetchMessagesFromCDNInternal(locale, smartlingProjectID, serviceIdentifier, params) {
  let messages = {};
  const translationEtag = params.etag,
    _params$cdnEnv3 = params.cdnEnv,
    cdnEnv = _params$cdnEnv3 === void 0 ? process.env.NODE_ENV : _params$cdnEnv3,
    db = params.db;
  try {
    const headers = translationEtag ? {
      'If-None-Match': translationEtag
    } : {};
    const primaryKey = `${smartlingProjectID}:${locale}`;
    const res = await fetchMessagesRaw(locale, smartlingProjectID, serviceIdentifier, {
      headers,
      cdnEnv
    });
    const status = res.status,
      responseHeaders = res.headers;

    // If there is no file and access denied return an empty obj
    if (status === 403) {
      return messages;
    }

    // Nothing has changed so return from DB
    if (status === 304) {
      messages = await retrieveIDBMessages(db, primaryKey);
      return messages;
    }

    // First successful fetch or found updated messages
    if (status === 200) {
      messages = await parseMessagesPayload(res);

      // TODO Test Etag storage after 1% launch
      const newEtag = responseHeaders.get('ETag') ?? '';
      await db.put('etags', newEtag, primaryKey);
      await db.put('messages', messages, primaryKey);
      return messages;
    }
    throw new Error();
  } catch (error) {
    if (cdnEnv !== 'production') {
      // eslint-disable-next-line no-console
      console.error(error);
    }
    return messages;
  }
}
async function fetchMessagesFromCDN(locale, smartlingProjectID, serviceIdentifier, additionalParams) {
  if (!locale || !smartlingProjectID || locale === DEFAULT_LOCALE) {
    return {};
  }
  const _ref4 = additionalParams ?? {},
    cdnEnv = _ref4.env;
  const dbName = `translations`;
  const db = await initiateIDB(dbName);
  const key = `${smartlingProjectID}:${locale}`;
  const translationEtag = await retrieveEtag(db, key);
  try {
    const messages = await fetchMessagesFromCDNInternal(locale, smartlingProjectID, serviceIdentifier, {
      etag: translationEtag,
      db,
      cdnEnv
    });
    return messages;
  } catch (error) {
    if (cdnEnv !== 'production') {
      // eslint-disable-next-line no-console
      console.error(error);
    }
    return {};
  }
}
async function fetchMessagesOnServer(locale, smartlingProjectID, serviceIdentifier, additionalParams) {
  if (!locale || !smartlingProjectID || locale === DEFAULT_LOCALE) {
    return {};
  }
  const _ref5 = additionalParams ?? {},
    cdnEnv = _ref5.env;
  return parseMessagesPayload(await fetchMessagesRaw(locale, smartlingProjectID, serviceIdentifier, {
    cdnEnv,
    headers: {}
  }));
}
export { Apps, DEC_2018_SUPPORTED_EUROPEAN_COUNTRIES, DEFAULT_LOCALE, DEFAULT_LOGGED_OUT_CONFIG, DEFAULT_REGION, DEFAULT_SUPPORTED_LANGUAGES, EFTA_LIST, EUROPEAN_UNION_LIST, FALLBACK_LOCALES, GDPR_COUNTRIES, LOCALE_CONVERSIONS, OFFICIAL_EU_COUNTRIES, SUPPORTED_LOCALES, autoRedirection, computeLocaleCode, convertToCBSupported, fetchMessagesFromCDN, fetchMessagesOnServer, fetchSupportedLocalesWithFallback, getCbSupportedClientLocale, getClientFallbackLocaleCode, getClientLocale, getCurrencyForRegion, getLocaleCodeWithoutRegion, getLocaleFallback, getLocalizedURL, getLoggedOutConfig, getLoggedOutConfigFor, getLoggedOutConfigList, getLoggedOutFallbackLocales, getRegionFromLocaleCode, getSupportedLocalesFromConfig, initiateIDB, isGdprCountry, isInEU, isPathLocalized, isValidConfigMapKey, isValidCurrencyCode, languages, localeCodeToDisplayName, loggedOutConfig, lookupFromPredefinedList, normalizeLocale, regionsLA, supportedCountryCodes };
//# sourceMappingURL=index.js.map
